import { Controller } from '@hotwired/stimulus';
import Rails from '@rails/ujs';

const HIDDEN_ROW_CLASS = "platform-filter-hidden"
const SELECTED_TILE_CLASS = "end-user-privacy__platform-filter-tile--selected"

export default class extends Controller {
  static targets = ["tile", "row", "section", "emptyState"];
  static values = {
    endpoint: String,
  }

  connect() {
    this.selected = new Set(
      this.tileTargets
        .filter(tile => tile.getAttribute("aria-pressed") === "true")
        .map(tile => tile.dataset.platform)
    )
    this.applyFilter()
  }

  toggleTile(event) {
    const tile = event.currentTarget
    const platform = tile.dataset.platform

    if (this.selected.has(platform)) {
      this.selected.delete(platform)
    } else {
      this.selected.add(platform)
    }

    tile.classList.toggle(SELECTED_TILE_CLASS, this.selected.has(platform))
    tile.setAttribute("aria-pressed", this.selected.has(platform))

    this.persist()
    this.applyFilter()
  }

  persist() {
    const params = new URLSearchParams()
    this.selected.forEach(platform => params.append("platforms[]", platform))

    Rails.ajax({
      type: "PATCH",
      url: this.endpointValue,
      data: params.toString()
    })
  }

  applyFilter() {
    if (this.selected.size === 0) {
      this.sectionTargets.forEach(section => section.hidden = true)
      if (this.hasEmptyStateTarget) this.emptyStateTarget.hidden = false
      this.dispatchCountUpdate()
      return
    }

    if (this.hasEmptyStateTarget) this.emptyStateTarget.hidden = true

    this.rowTargets.forEach(row => {
      const platforms = JSON.parse(row.dataset.expandedPlatforms || "[]")
      const matches = platforms.some(platform => this.selected.has(platform))
      row.classList.toggle(HIDDEN_ROW_CLASS, !matches)
    })

    this.sectionTargets.forEach(section => {
      if (section.dataset.sectionPlatforms) {
        // Sections without per-row platform data (e.g. web apps) declare
        // their platforms on the section itself.
        const sectionPlatforms = JSON.parse(section.dataset.sectionPlatforms)
        section.hidden = !sectionPlatforms.some(platform => this.selected.has(platform))
      } else {
        section.hidden = this.visibleRowsIn(section).length === 0
      }

      if (!section.hidden) this.stripeSection(section)
    })

    this.dispatchCountUpdate()
  }

  visibleRowsIn(section) {
    return this.rowTargets.filter(row => section.contains(row) && !row.classList.contains(HIDDEN_ROW_CLASS))
  }

  stripeSection(section) {
    this.visibleRowsIn(section).forEach((row, index) => {
      row.classList.toggle("even", index % 2 === 0)
      row.classList.toggle("odd", index % 2 !== 0)
    })
  }

  dispatchCountUpdate() {
    window.dispatchEvent(new CustomEvent('updateEndUserAccessPrivacyCountable', { cancelable: true }))
    // Run it one more time in case this is on page-load and the events haven't
    // been registered. This is a bit of a hack.
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('updateEndUserAccessPrivacyCountable', { cancelable: true }))
    }, 300)
  }
}
